import type { PlaylistItem } from '@jwp/ott-common/types/playlist';
import type { ScreenComponent } from '@jwp/ott-ui-react/types/screens';
import { useConfigStore } from '@jwp/ott-common/src/stores/ConfigStore';

import MediaVideoCinema from './MediaVideoCinema';
import MediaVideoInline from './MediaVideoInline';

const MediaVideo: ScreenComponent<PlaylistItem> = ({ data, isLoading }) => {
  const inlineLayout = useConfigStore((s) => !!s.config?.custom?.inlinePlayer);
  return inlineLayout ? <MediaVideoInline data={data} isLoading={isLoading} /> : <MediaVideoCinema data={data} isLoading={isLoading} />;
};

export default MediaVideo;
